import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { Header, HeaderLabel, HeaderButton } from '../../styles';
import keys from '../../../../../utils/keys';

interface InnerPanelProps {
	onConfirm: () => void;
	onClose: () => void;
	children: React.ReactNode;
	isError?: boolean;
}

const InnerPanel = ({ onConfirm, onClose, children, isError }: InnerPanelProps) => {
	React.useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (keys.isEnter(e.key)) {
				e.preventDefault();
				onConfirm();
			}

			if (keys.isEsc(e.key)) {
				onClose();
			}
		};

		window.addEventListener('keydown', handleKeyDown);

		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [onClose, onConfirm]);

	return (
		<div>
			<Header>
				<HeaderButton onClick={onClose}>
					<Translate value="messages.cancel" />
				</HeaderButton>
				<HeaderLabel value="messages.add" />
				<HeaderButton
					disabled={isError}
					onClick={onConfirm}
				>
					<Translate value="messages.ok" />
				</HeaderButton>
			</Header>
			{children}
		</div>
	);
};

export default InnerPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SettingsPanel/InnerPanel/index.tsx